/**
 * Auto-rotating crossfade carousel. Mirrors the React Carousel: advance every
 * `data-carousel-interval` ms (default 5000); dots jump to a slide and restart
 * the timer. Supports multiple carousels on a page.
 */
(function () {
  var carousels = document.querySelectorAll('[data-carousel]');

  for (var c = 0; c < carousels.length; c++) {
    setupCarousel(carousels[c]);
  }

  function setupCarousel(root) {
    var slides = root.querySelectorAll('[data-carousel-slide]');
    var dots = root.querySelectorAll('[data-carousel-dot]');
    if (slides.length <= 1) return;

    var intervalMs = parseInt(root.getAttribute('data-carousel-interval'), 10) || 5000;
    var index = 0;
    var timer;

    function setSlide(i, on) {
      if (!slides[i]) return;
      slides[i].classList.toggle('is-active', on);
      slides[i].setAttribute('aria-hidden', on ? 'false' : 'true');
    }

    function setDot(i, on) {
      if (!dots[i]) return;
      dots[i].classList.toggle('is-active', on);
      dots[i].setAttribute('aria-current', on ? 'true' : 'false');
    }

    function show(next) {
      setSlide(index, false);
      setDot(index, false);
      index = (next + slides.length) % slides.length;
      setSlide(index, true);
      setDot(index, true);
    }

    function start() {
      timer = window.setInterval(function () {
        show(index + 1);
      }, intervalMs);
    }

    function restart() {
      window.clearInterval(timer);
      start();
    }

    for (var i = 0; i < dots.length; i++) {
      (function (slideIndex) {
        dots[slideIndex].addEventListener('click', function () {
          show(slideIndex);
          restart();
        });
      })(i);
    }

    start();
  }
})();
